import type IAIDraftUnitItem from 'store/slices/valueChainMap/interfaces/IAIDraftUnitItem';

const hasAIDraftResults = (draftData?: IAIDraftUnitItem): boolean => Boolean(
  draftData
  && (
    draftData.draftColumns.length > 0
    || draftData.draftUnits.length > 0
    || (draftData.draftConnections || []).length > 0
  ),
);

export default hasAIDraftResults;
